module.exports = __webpack_public_path__ + "static/assets/9073974a46352f66214bf99db01aab28.svg";